import React, { useState, useEffect } from 'react';
import {
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Box,
    CircularProgress,
    Chip,
    OutlinedInput
} from '@mui/material';
import { reconciliationService } from '../../../../services/reportService';

const WarehouseFilter = ({ selectedWarehouse, onWarehouseChange }) => {
    const [warehouses, setWarehouses] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchWarehouses();
    }, []);

    const fetchWarehouses = async () => {
        setLoading(true);
        setError(null);
        try {
            const response = await reconciliationService.getWarehouses();
            if (response.data.success) {
                setWarehouses(response.data.data);
            } else {
                setError('Failed to load warehouses');
            }
        } catch (err) {
            setError(err.message || 'Error loading warehouses');
            console.error('Error fetching warehouses:', err);
        } finally {
            setLoading(false);
        }
    };

    const handleChange = (event) => {
        onWarehouseChange(event.target.value);
    };

    return (
        <FormControl sx={{ minWidth: 200, mr: 2 }}>
            <InputLabel id="warehouse-filter-label">Warehouse</InputLabel>
            <Select
                labelId="warehouse-filter-label"
                id="warehouse-filter"
                value={selectedWarehouse || ''}
                onChange={handleChange}
                input={<OutlinedInput label="Warehouse" />}
                disabled={loading}
                renderValue={(selected) => {
                    if (!selected) return 'All Warehouses';
                    const warehouse = warehouses.find(w => w.id === selected);
                    return warehouse ? `${warehouse.name}` : selected;
                }}
            >
                <MenuItem value="">
                    <em>All Warehouses</em>
                </MenuItem>
                {warehouses.map((warehouse) => (
                    <MenuItem key={warehouse.id} value={warehouse.id}>
                        <Box>
                            <Chip
                                label={warehouse.name}
                                size="small"
                                color="primary"
                                variant="outlined"
                                sx={{ mr: 1 }}
                            />
                            {warehouse.name}
                            {warehouse.location && (
                                <Box component="span" sx={{ ml: 1, color: 'text.secondary', fontSize: '0.8rem' }}>
                                    ({warehouse.location})
                                </Box>
                            )}
                        </Box>
                    </MenuItem>
                ))}
            </Select>
            {loading && (
                <Box sx={{ display: 'flex', alignItems: 'center', ml: 1 }}>
                    <CircularProgress size={20} />
                </Box>
            )}
            {error && (
                <Box sx={{ color: 'error.main', fontSize: '0.75rem', ml: 1 }}>
                    {error}
                </Box>
            )}
        </FormControl>
    );
};

export default WarehouseFilter;